import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as dayjs from 'dayjs';
import { merge } from 'rxjs';
import { takeUntil, tap, map, switchMap, delay, startWith } from 'rxjs/operators';
import { DateService } from '../../../../../providers/date/date.service';
import { NoteHttpService } from '../../../../../providers/note/note.http.service';
import { trackExecutionHttp } from '../../../../rxjs/track-execution-http.operator';
import { DestroyableComponent } from '../../../../utils/destroyable.component';
import { Loader, LoaderType } from '../../../../utils/loader.util';
import { QuoteNoteControlComponent } from '../../../custom-controls/quote-note-control/quote-note-control.component';
import { TimelineViewComponent } from '../../../custom-views/components/timeline/timeline-view/timeline-view.component';

interface DialogData {
  quoteId: number,
}

@Component({
  selector: 'app-add-quote-note-modal',
  templateUrl: './add-quote-note-modal.component.html',
  styleUrls: ['./add-quote-note-modal.component.scss'],
})
export class AddQuoteNoteModalComponent extends DestroyableComponent implements OnInit {

  @ViewChild(QuoteNoteControlComponent) quoteNoteControlComponent: QuoteNoteControlComponent;
  @ViewChild(TimelineViewComponent) timelineViewComponent: TimelineViewComponent;

  reloadNotes: EventEmitter<unknown> = new EventEmitter();

  public message: string;
  constructor(
    private readonly noteHttpService: NoteHttpService,
    private readonly dateService: DateService,
    public dialogRef: MatDialogRef<AddQuoteNoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
  ) {
    super();
  }

  items: Array<{ message: string; date: string; personName: string; avatarUrl: string }>;

  loaderKey: LoaderType = 'local';
  loader = Loader.create().add(this.loaderKey);
  loading$ = this.loader.isLoadingObservable(this.loaderKey);

  ngOnInit() {
    const getQuoteNotes$ = this.noteHttpService.getQuoteNotes(this.dialogData.quoteId).pipe(
      takeUntil(this.onDestroy),
      delay(1000),
      trackExecutionHttp(this.loaderKey, this.loader),
      map(x => x.data.map(note => ({
        message: note.message,
        date: dayjs(note.createdAt).format('MM/DD/YYYY'),
        personName: `${note.createdBy.firstName} ${note.createdBy.lastName}`,
        avatarUrl: note.createdBy.avatarUrl,
      }))),
      tap(items => this.items = items)
    );

    merge(this.reloadNotes).pipe(
      takeUntil(this.onDestroy),
      startWith({}),
      delay(0),
      switchMap(() => getQuoteNotes$)
    ).subscribe()
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    const message = this.quoteNoteControlComponent.message;
    this.quoteNoteControlComponent.clearMessage();
    this.noteHttpService.createQuoteNote(this.dialogData.quoteId, {
      message,
      date: this.dateService.toIsoDateNow()
    }).pipe(
      takeUntil(this.onDestroy),
      tap(() => this.reloadNotes.emit()),
    )
      .subscribe();
  }
}
